export enum FILE_TYPES {
  image = 'image/*',
  video = 'video/*',
  pdf = '.pdf',
  document = '.doc,.pdf,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  any = '',
}
